import React from 'react';
import { ColorOption, Styler, StylerProps, TextColorOption, TypographyHero } from '@honeycomb/ui-core';

export interface TrSquareBadgeProps extends StylerProps {
    backgroundColor: ColorOption;
    textColor: TextColorOption;
    text: string;
}

export function TrSquareBadge(props: TrSquareBadgeProps): React.JSX.Element {
    const { backgroundColor, textColor, text, ...other } = props;

    return (
        <Styler
            p={3}
            br={10}
            bg={backgroundColor}
            c={textColor}
            display="flex"
            justifyContent="center"
            alignItems="center"
            {...other}
        >
            <TypographyHero weight="bold" ta="center" size="s">
                {text}
            </TypographyHero>
        </Styler>
    );
}
